
<template>
  <div class="top-article-box" style="user-select: none;">
    <div class="article-box-shadow"></div>
    <a :href="article.path" class="top-article-box-link">
      <img :src="article.image_path" width="240px" height="135px" draggable="false">
      <div class="top-article-date">{{article.date}}</div>
      <div class="top-article-title">{{article.title}}</div>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  props: {
    article: {
      type: Object,
      default: () => {}
    },
  },
  components: {
  },
  methods: {
    
  },
  created(){
  },
  computed: {
  },
  watch: {
  }
}
</script>